import { render, staticRenderFns } from "./AdminUpdateDDATSuccess.vue?vue&type=template&id=64c50c65"
import script from "./AdminUpdateDDATSuccess.vue?vue&type=script&lang=js"
export * from "./AdminUpdateDDATSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports